import { getChannelSimOptions, updateChannelSimOptions, getIoSimContent, getDownloadOptions } from "../../api/Himalayas/channel";
import apiProcess from "../../api/utility";

function getSimulationOptions(channelId) {
  return apiProcess(getChannelSimOptions, channelId);
}

function updateSimulationOptions({ channelId, options, allInterfaces }) {
  return apiProcess(updateChannelSimOptions, { channelId, options, allInterfaces })
}

function getIoSimContentPromise(channelId) {
  return apiProcess(getIoSimContent, channelId)
}

function getDownloadOptionsPromise(channelIds) {
  return new Promise(function (resolve, reject) {
    apiProcess(getDownloadOptions, channelIds).then(res => {
      resolve(res);
    }, error => {
      resolve({});
    })
  })
}

export {
  getSimulationOptions,
  updateSimulationOptions,
  getIoSimContentPromise,
  getDownloadOptionsPromise
}